import { useContext } from 'react';
import Context from './Context';
export { default as withCarts } from './with';
export { default } from './Provider';

export function useCarts() {
  return useContext(Context);
}
